import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { demandasService } from '../services/api';
import { fmtDateTime, fmtRelativeTime } from '../utils/formatters';
import { useAuth } from '../contexts/AuthContext';
import MarkdownView from './MarkdownView';
import { mensagemDoErroDeCarga, opcaoAtualForaDaLista, campo, useEstadoDaCarga, EstadoDaLista, A_PROPRIA_LISTA_DIZ_O_VAZIO } from '../design';
import CascaDeModal from './shared/CascaDeModal';
import { useConfirmarPerigo, useConfirm } from './shared/ConfirmDialog';
import { useAviso } from './shared/Aviso';
import { TONE_BADGE, TONE_TEXT, TONE_BORDER, StatusTone } from '../utils/statusColors';
import { ACEITA_NO_SELETOR, porqueRecusarArquivo, avisoDaCriacaoComFalha, avisoDoComentarioComFalha, FRASE_DO_RESPONSAVEL, confirmacaoDeDescartar, confirmacaoDeRemoverAnexo, avisoDoLinkSemDemanda, Falha } from '../utils/demandas';

const Icon = ({ name, className = 'w-5 h-5' }: { name: string; className?: string }) => {
  const icons: any = {
    clipboard: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' /></svg>,
    x: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' /></svg>,
    plus: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4v16m8-8H4' /></svg>,
    trash: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' /></svg>,
    search: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' /></svg>,
    edit: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' /></svg>,
    check: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' /></svg>,
    clock: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    ban: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636' /></svg>,
    paperclip: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13' /></svg>,
    refresh: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' /></svg>,
    list: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 10h16M4 14h16M4 18h16' /></svg>,
    kanban: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2' /></svg>,
    send: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5' /></svg>,
    user: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' /></svg>,
    image: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z' /></svg>,
    download: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4' /></svg>,
    link: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13.828 10.172a4 4 0 010 5.656l-3 3a4 4 0 01-5.656-5.656l1.5-1.5m7.5-7.5l1.5-1.5a4 4 0 015.656 5.656l-3 3a4 4 0 01-5.656 0' /></svg>,
    chart: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' /></svg>,
  };
  return icons[name] || null;
};

interface HubUser {
  id: number;
  name: string;
  role: string;
}

interface DemandAttachment {
  id: number;
  demandId: number;
  commentId?: number | null;
  filename: string;
  originalName: string;
  mimeType: string;
  size: number;
  uploadedById?: number;
  uploadedBy?: HubUser;
  createdAt: string;
}

interface DemandComment {
  id: number;
  demandId: number;
  authorId: number;
  author?: HubUser;
  kind: 'comment' | 'status_change';
  body?: string | null;
  metadata?: { from?: string; to?: string };
  createdAt: string;
}

interface Demand {
  id: number;
  sequencial: number;
  code: string;
  title: string;
  description?: string;
  system: string;
  type: string;
  priority: string;
  status: string;
  clientName?: string;
  reporterId: number;
  reporter?: HubUser;
  assigneeId?: number | null;
  assignee?: HubUser | null;
  comments?: DemandComment[];
  attachments?: DemandAttachment[];
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
}

interface PendingAttachment {
  filename: string;
  fileBase64: string;
  isImage: boolean;
}

const SYSTEM_LABELS: Record<string, string> = {
  atendimento: 'Atendimento',
  hub: 'HUB',
  pabx: 'PABX',
  outro: 'Outro',
};

const TYPE_LABELS: Record<string, string> = {
  bug: 'Bug',
  melhoria: 'Melhoria',
  implementacao: 'Implementação',
};

// Cor (11/10/2026, PR-2 da medição): tipo, prioridade e status saem do mapa de tons, não da paleta crua. Significado
// por tom: defeito = danger, urgência = warning/danger, concluída = success, descartada = neutral.
const comBorda = (t: StatusTone) => `${TONE_BADGE[t]} ${TONE_BORDER[t]}`;

const TYPE_COLORS: Record<string, string> = {
  bug: comBorda('danger'),
  melhoria: comBorda('progress'),
  implementacao: comBorda('info'),
};

const PRIORITY_LABELS: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
};

// "Alta" era laranja, o acento da ação primária: urgência é warning.
const PRIORITY_COLORS: Record<string, string> = {
  baixa: comBorda('neutral'),
  media: comBorda('progress'),
  alta: comBorda('warning'),
  urgente: comBorda('danger'),
};

const STATUS_LABELS: Record<string, string> = {
  aberta: 'Aberta',
  em_andamento: 'Em andamento',
  aguardando_validacao: 'Aguardando validação',
  concluida: 'Concluída',
  descartada: 'Descartada',
};

const STATUS_TONE: Record<string, StatusTone> = {
  aberta: 'progress',
  em_andamento: 'warning',
  aguardando_validacao: 'info',
  concluida: 'success',
  descartada: 'neutral',
};
// O ponto da linha do tempo: classe escrita por extenso (o Tailwind não gera classe montada em tempo de execução).
const STATUS_DOT: Record<string, string> = {
  aberta: 'bg-blue-400',
  em_andamento: 'bg-amber-400',
  aguardando_validacao: 'bg-purple-400',
  concluida: 'bg-emerald-400',
  descartada: 'bg-slate-400',
};

const ACAO_NEUTRA = 'bg-slate-700/60 text-slate-200 border-slate-600 hover:bg-slate-600';
const ACAO_PRIMARIA = 'bg-primary text-white border-transparent hover:bg-primary-strong';

const KANBAN_COLUMNS = ['aberta', 'em_andamento', 'aguardando_validacao', 'concluida', 'descartada'];

// Espelho das transições do backend
const ALLOWED_TRANSITIONS: Record<string, string[]> = {
  aberta: ['em_andamento', 'aguardando_validacao', 'concluida', 'descartada'],
  em_andamento: ['aberta', 'aguardando_validacao', 'concluida', 'descartada'],
  aguardando_validacao: ['em_andamento', 'concluida', 'descartada'],
  concluida: ['aberta'],
  descartada: ['aberta'],
};

const formatBytes = (bytes: number) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return (bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1) + ' ' + sizes[i];
};

// Thumbnail de anexo — baixa o blob autenticado e mostra preview p/ imagens
function AttachmentCard({ attachment, canDelete, onDelete }: { attachment: DemandAttachment; canDelete: boolean; onDelete: () => void }) {
  const [thumbUrl, setThumbUrl] = useState<string | null>(null);
  const isImage = attachment.mimeType.startsWith('image/');

  useEffect(() => {
    let revoked = false;
    let url: string | null = null;
    if (isImage) {
      demandasService.getAttachmentBlobUrl(attachment.demandId, attachment.id).then((u) => {
        if (revoked) { window.URL.revokeObjectURL(u); return; }
        url = u;
        setThumbUrl(u);
      }).catch(() => {});
    }
    return () => {
      revoked = true;
      if (url) window.URL.revokeObjectURL(url);
    };
  }, [attachment.demandId, attachment.id, isImage]);

  return (
    <div className='relative group bg-slate-800 border border-slate-700 rounded-lg overflow-hidden'>
      <button
        onClick={() => demandasService.viewAttachment(attachment.demandId, attachment.id)}
        className='block w-full text-left'
        title={`${attachment.originalName} (${formatBytes(attachment.size)})`}
      >
        {isImage ? (
          thumbUrl ? (
            <img src={thumbUrl} alt={attachment.originalName} className='h-24 w-full object-cover' />
          ) : (
            <div className='h-24 w-full flex items-center justify-center text-slate-600'>
              <Icon name='image' className='w-6 h-6' />
            </div>
          )
        ) : (
          <div className='h-24 w-full flex flex-col items-center justify-center gap-1 text-slate-400'>
            <Icon name='paperclip' className='w-6 h-6' />
            <span className='text-[10px] px-2 truncate max-w-full'>{attachment.originalName}</span>
          </div>
        )}
      </button>
      <div className='px-2 py-1 text-[10px] text-slate-500 truncate border-t border-slate-700'>{attachment.originalName}</div>
      <div className='absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity'>
        <button
          onClick={(e) => { e.stopPropagation(); demandasService.downloadAttachment(attachment.demandId, attachment.id, attachment.originalName); }}
          className='p-1 bg-slate-900/80 text-slate-300 rounded hover:bg-slate-700'
          title='Baixar'
        >
          <Icon name='download' className='w-3 h-3' />
        </button>
        {canDelete && (
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(); }}
            className='p-1 bg-red-500/80 text-white rounded hover:bg-red-600'
            title='Remover anexo'
          >
            <Icon name='trash' className='w-3 h-3' />
          </button>
        )}
      </div>
    </div>
  );
}

// Controle de "visto" por demanda (localStorage) — dot de atividade nova na lista.
// baseline = primeira visita: nada anterior a ela conta como novo (evita flood inicial).
const SEEN_KEY = 'demandas_seen_v1';
type SeenStore = { baseline: string; seen: Record<number, string> };
const loadSeenStore = (): SeenStore => {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  const fresh: SeenStore = { baseline: new Date().toISOString(), seen: {} };
  try { localStorage.setItem(SEEN_KEY, JSON.stringify(fresh)); } catch { /* ignore */ }
  return fresh;
};

export default function DemandasTab({ onOpenCountChange, deepCode }: { onOpenCountChange?: () => void; deepCode?: string | null }) {
  const confirmarPerigo = useConfirmarPerigo();
  const confirmar = useConfirm();
  // D6 (11/10/2026): os 9 alert() viram o aviso do HUB.
  const avisar = useAviso();
  const falhou = (e: any) => { const msg = e?.response?.data?.message; return Array.isArray(msg) ? msg.join('; ') : msg || mensagemDoErroDeCarga(e); };
  // D3: a lista calava; na falha dizia "Nenhuma demanda encontrada" com "Nova Demanda" ao lado e as métricas em zero.
  const carga = useEstadoDaCarga();
  const rodarCarga = carga.rodar;
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  const [demands, setDemands] = useState<Demand[]>([]);
  const [users, setUsers] = useState<HubUser[]>([]);
  // A lista de pessoas NÃO CARREGOU (08/10/2026). Antes, `getUsers().catch(() => [])`: o select do responsável ficava
  // sem a pessoa e mostrava "Sem responsável" numa demanda que TEM responsável, e o filtro perdia as pessoas. Nada se
  // gravava errado, mas o campo de decisão afirmava o falso. Agora o responsável atual é sempre opção (vem na própria
  // demanda), o filtro usa as pessoas que constam nas demandas, e a tela diz que a lista não carregou.
  const [erroDosUsuarios, setErroDosUsuarios] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState<'list' | 'kanban'>('list');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('Todos');
  const [systemFilter, setSystemFilter] = useState('Todos');
  const [typeFilter, setTypeFilter] = useState('Todos');
  const [priorityFilter, setPriorityFilter] = useState('Todos');
  const [assigneeFilter, setAssigneeFilter] = useState('Todos');
  const [showClosed, setShowClosed] = useState(false);

  const [modal, setModal] = useState<'create' | 'edit' | null>(null);
  const [detail, setDetail] = useState<Demand | null>(null);
  const [saving, setSaving] = useState(false);

  const emptyForm = { title: '', description: '', system: 'atendimento', type: 'bug', priority: 'media', clientName: '' };
  const [form, setForm] = useState<any>(emptyForm);
  const [pendingAtts, setPendingAtts] = useState<PendingAttachment[]>([]);

  const [commentText, setCommentText] = useState('');
  const [commentAtts, setCommentAtts] = useState<PendingAttachment[]>([]);
  const [sendingComment, setSendingComment] = useState(false);

  // Modal de conclusão (comentário obrigatório)
  const [concludeModal, setConcludeModal] = useState<Demand | null>(null);
  const [concludeComment, setConcludeComment] = useState('');

  // Filtro rápido minhas/criadas por mim + métricas + link copiado
  const [mineFilter, setMineFilter] = useState<'assignee' | 'reporter' | null>(null);
  const [showMetrics, setShowMetrics] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);

  // Atividade nova (dot laranja) — visto por demanda no localStorage
  const [seenStore, setSeenStore] = useState<SeenStore>(loadSeenStore);
  const markSeen = useCallback((id: number) => {
    setSeenStore((prev) => {
      const next: SeenStore = { ...prev, seen: { ...prev.seen, [id]: new Date().toISOString() } };
      try { localStorage.setItem(SEEN_KEY, JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  }, []);
  const hasNews = (d: Demand) =>
    new Date(d.updatedAt).getTime() > new Date(seenStore.seen[d.id] || seenStore.baseline).getTime();

  // Idade da demanda: aberta = dias desde a criação (cor por prioridade);
  // encerrada = lead time (criação → conclusão)
  const ageInfo = (d: Demand): { label: string; cls: string } => {
    const isClosed = d.status === 'concluida' || d.status === 'descartada';
    const end = isClosed ? new Date(d.completedAt || d.updatedAt).getTime() : Date.now();
    const days = Math.floor((end - new Date(d.createdAt).getTime()) / 86400000);
    const label = days < 1 ? '<1d' : `${days}d`;
    if (isClosed) return { label, cls: 'text-slate-500' };
    const limit = d.priority === 'urgente' ? 2 : d.priority === 'alta' ? 4 : 7;
    const cls = days >= limit ? 'text-red-400 font-semibold' : days >= Math.ceil(limit / 2) ? 'text-amber-400' : 'text-slate-400';
    return { label, cls };
  };

  const loadData = useCallback(async () => {
    setLoading(true);
    await rodarCarga(async () => {
      const [demandsData, usersData] = await Promise.all([
        demandasService.getAll({ includeClosed: true }),
        demandasService.getUsers().then(
          (u: any) => ({ u, erro: null as string | null }),
          (e: any) => ({ u: null, erro: mensagemDoErroDeCarga(e) }),
        ),
      ]);
      setDemands(Array.isArray(demandsData) ? demandsData : []);
      setErroDosUsuarios(usersData.erro);
      if (!usersData.erro) setUsers(Array.isArray(usersData.u) ? usersData.u : []);
    });
    setLoading(false);
  }, [rodarCarga]);

  useEffect(() => { loadData(); }, [loadData]);

  const refreshDetail = useCallback(async (id: number) => {
    try {
      const fresh = await demandasService.getById(id);
      setDetail(fresh);
      setLinkCopied(false);
      markSeen(id);
    } catch (e) {
      // D3: calava; o clique não abria nada, e depois de uma ação o detalhe ficava com o estado velho.
      avisar(`Não consegui abrir a demanda: ${mensagemDoErroDeCarga(e)}`, 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markSeen]);

  // Deep-link ?demanda=DEM-N → abre o detalhe assim que a lista carregar (1x)
  const deepConsumedRef = useRef(false);
  useEffect(() => {
    if (!deepCode || deepConsumedRef.current) return;
    const code = deepCode.trim().toUpperCase();
    // D3: o link que não achava a demanda (ou cuja lista não carregou) não fazia nada, calado.
    if (carga.estado === 'erro') { deepConsumedRef.current = true; avisar(avisoDoLinkSemDemanda(code, false), 'warning'); return; }
    if (carga.estado !== 'pronto') return;
    const target = demands.find((d) => d.code.toUpperCase() === code || d.code.toUpperCase() === `DEM-${code}`);
    deepConsumedRef.current = true;
    if (target) refreshDetail(target.id);
    else avisar(avisoDoLinkSemDemanda(code, true), 'warning');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deepCode, demands, refreshDetail, carga.estado]);

  const afterMutation = useCallback(async (detailId?: number) => {
    await loadData();
    if (detailId) await refreshDetail(detailId);
    onOpenCountChange?.();
  }, [loadData, refreshDetail, onOpenCountChange]);

  // === Permissões (espelho do backend; o back é a fonte de verdade) ===
  const canMove = (d: Demand, to: string): boolean => {
    if (!user || to === d.status) return false;
    if (!(ALLOWED_TRANSITIONS[d.status] || []).includes(to)) return false;
    if (to === 'descartada') return isAdmin;
    if (isAdmin || d.assigneeId === user.id) return true;
    return d.reporterId === user.id && d.status === 'aguardando_validacao' && (to === 'concluida' || to === 'em_andamento');
  };
  const canDrag = (d: Demand): boolean =>
    isAdmin || d.assigneeId === user?.id || (d.reporterId === user?.id && d.status === 'aguardando_validacao');
  const canEditDemand = (d: Demand): boolean => isAdmin || d.reporterId === user?.id;
  const canChangeAssignee = (d: Demand): boolean => isAdmin || d.assigneeId === user?.id;

  /** Pessoas do filtro: a lista de usuários, mais quem consta como responsável nas demandas (vem nelas, com o nome). */
  const pessoasDoFiltro = useMemo(() => {
    const m = new Map<number, HubUser>();
    for (const u of users) m.set(u.id, u);
    for (const d of demands) if (d.assignee && !m.has(d.assignee.id)) m.set(d.assignee.id, d.assignee);
    return Array.from(m.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [users, demands]);

  // === Paste/upload de anexos pendentes ===
  const readFileToPending = (file: File, add: (att: PendingAttachment) => void) => {
    // D1: tamanho e tipo conferidos ANTES (o servidor recusava depois de criar a demanda).
    const recusa = porqueRecusarArquivo(file);
    if (recusa) { avisar(recusa, 'warning'); return; }
    const reader = new FileReader();
    reader.onload = () => {
      const ext = file.type === 'image/png' ? 'png' : (file.name.split('.').pop() || 'png');
      const filename = file.name && file.name !== 'image.png' ? file.name : `screenshot-${Date.now()}.${ext}`;
      add({ filename, fileBase64: reader.result as string, isImage: file.type.startsWith('image/') });
    };
    reader.readAsDataURL(file);
  };

  const handlePaste = (e: React.ClipboardEvent, add: (att: PendingAttachment) => void) => {
    const items = e.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          e.preventDefault();
          readFileToPending(file, add);
        }
      }
    }
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>, add: (att: PendingAttachment) => void) => {
    const files = e.target.files;
    if (!files) return;
    for (let i = 0; i < files.length; i++) readFileToPending(files[i], add);
    e.target.value = '';
  };

  // Drop de arquivo no modal → vira anexo pendente (mesmo pipeline do paste/seleção)
  const handleDropFiles = (e: React.DragEvent, add: (att: PendingAttachment) => void) => {
    e.preventDefault();
    const files = e.dataTransfer?.files;
    if (!files) return;
    for (let i = 0; i < files.length; i++) readFileToPending(files[i], add);
  };

  const renderPendingChips = (atts: PendingAttachment[], remove: (idx: number) => void) => {
    if (atts.length === 0) return null;
    return (
      <div className='flex flex-wrap gap-2 mt-2'>
        {atts.map((att, idx) => (
          <div key={idx} className='flex items-center gap-2 bg-slate-800 border border-slate-700 rounded-lg pl-1 pr-2 py-1'>
            {att.isImage ? (
              <img src={att.fileBase64} alt={att.filename} className='h-8 w-8 object-cover rounded' />
            ) : (
              <Icon name='paperclip' className='w-4 h-4 text-slate-400' />
            )}
            <span className='text-xs text-slate-300 max-w-[140px] truncate'>{att.filename}</span>
            <button onClick={() => remove(idx)} className='text-slate-500 hover:text-red-400'>
              <Icon name='x' className='w-3.5 h-3.5' />
            </button>
          </div>
        ))}
      </div>
    );
  };

  // === CRUD ===
  const handleCreate = () => {
    setForm(emptyForm);
    setPendingAtts([]);
    setModal('create');
  };

  const handleEdit = (d: Demand) => {
    setForm({
      title: d.title,
      description: d.description || '',
      system: d.system,
      type: d.type,
      priority: d.priority,
      clientName: d.clientName || '',
    });
    setPendingAtts([]);
    setModal('edit');
  };

  const handleSave = async () => {
    if (!form.title.trim()) { avisar('Informe o título da demanda', 'warning'); return; }
    setSaving(true);
    try {
      const payload = {
        title: form.title.trim(),
        description: form.description || undefined,
        system: form.system,
        type: form.type,
        priority: form.priority,
        clientName: form.clientName?.trim() || undefined,
      };
      if (modal === 'edit' && detail) {
        await demandasService.update(detail.id, payload);
        setModal(null);
        await afterMutation(detail.id);
      } else {
        const created = await demandasService.create(payload);
        // D1 (11/10/2026): o create e os anexos estavam no mesmo try. Um anexo que falhava dava "Erro ao salvar" com o form
        // preenchido sobre uma demanda JÁ CRIADA, e o segundo clique criava outra. Agora: criada, a demanda abre; o anexo
        // que falhou fica pendente no comentário dela, com o motivo.
        const falhas: Falha[] = [];
        const faltaram: PendingAttachment[] = [];
        for (const att of pendingAtts) {
          try {
            await demandasService.addAttachment(created.id, { filename: att.filename, fileBase64: att.fileBase64 });
          } catch (e: any) { falhas.push({ filename: att.filename, motivo: falhou(e) }); faltaram.push(att); }
        }
        setModal(null);
        setPendingAtts([]);
        setDetail(created);
        setCommentAtts(faltaram);
        if (falhas.length) avisar(avisoDaCriacaoComFalha(created.code, falhas), 'warning');
        else avisar(`${created.code} criada.`, 'success');
        await afterMutation(created.id);
      }
    } catch (e: any) {
      avisar(`Não salvei: ${falhou(e)}`, 'error');
    }
    setSaving(false);
  };

  const handleDelete = async (d: Demand) => {
    if (!await confirmarPerigo(`Excluir a demanda ${d.code}?`)) return;
    try {
      await demandasService.delete(d.id);
      setDetail(null);
      await afterMutation();
    } catch (e: any) {
      avisar('Erro ao excluir: ' + (e.response?.data?.message || e.message), 'error');
    }
  };

  const doChangeStatus = async (d: Demand, to: string, comment?: string) => {
    try {
      await demandasService.changeStatus(d.id, to, comment);
      await afterMutation(detail?.id === d.id ? d.id : undefined);
    } catch (e: any) {
      avisar('Erro ao mudar status: ' + (e.response?.data?.message || e.message), 'error');
    }
  };

  const requestStatusChange = async (d: Demand, to: string) => {
    if (to === 'descartada' && !(await confirmar(confirmacaoDeDescartar(d)))) return;
    if (to === 'concluida') {
      setConcludeComment('');
      setConcludeModal(d);
    } else {
      doChangeStatus(d, to);
    }
  };

  const handleConclude = async () => {
    if (!concludeModal) return;
    if (!concludeComment.trim()) { avisar('Concluir exige um comentário descrevendo o que foi feito', 'warning'); return; }
    const d = concludeModal;
    setConcludeModal(null);
    await doChangeStatus(d, 'concluida', concludeComment.trim());
  };

  const handleChangeAssignee = async (d: Demand, assigneeId: number | null) => {
    try {
      await demandasService.changeAssignee(d.id, assigneeId);
      await afterMutation(d.id);
    } catch (e: any) {
      avisar('Erro ao mudar responsável: ' + (e.response?.data?.message || e.message), 'error');
    }
  };

  const handleSendComment = async () => {
    if (!detail) return;
    if (!commentText.trim() && commentAtts.length === 0) return;
    setSendingComment(true);
    let commentId: number | undefined;
    try {
      if (commentText.trim()) {
        const comment = await demandasService.addComment(detail.id, commentText.trim());
        commentId = comment.id;
      }
    } catch (e: any) {
      avisar(`Não enviei o comentário: ${falhou(e)}`, 'error');
      setSendingComment(false);
      return;
    }
    // D2: o comentário saiu; os anexos que falharem ficam no campo, e o texto sai (reenviar duplicava o comentário).
    const falhas: Falha[] = [];
    const faltaram: PendingAttachment[] = [];
    for (const att of commentAtts) {
      try {
        await demandasService.addAttachment(detail.id, { filename: att.filename, fileBase64: att.fileBase64, commentId });
      } catch (e: any) { falhas.push({ filename: att.filename, motivo: falhou(e) }); faltaram.push(att); }
    }
    setCommentText('');
    setCommentAtts(faltaram);
    if (falhas.length) avisar(avisoDoComentarioComFalha(falhas), 'warning');
    await refreshDetail(detail.id);
    setSendingComment(false);
  };

  const handleDeleteAttachment = async (att: DemandAttachment) => {
    if (!await confirmarPerigo(confirmacaoDeRemoverAnexo(att))) return;
    try {
      await demandasService.removeAttachment(att.demandId, att.id);
      if (detail) await refreshDetail(detail.id);
    } catch (e: any) {
      avisar('Erro ao remover anexo: ' + (e.response?.data?.message || e.message), 'error');
    }
  };

  // === Filtros (client-side) ===
  // O gate de encerradas fica FORA dos demais para a tela conseguir contar o que
  // ele está escondendo. Sem isso, buscar uma demanda descartada respondia
  // "Nenhuma demanda encontrada" — a tela negava a existência de uma demanda que
  // estava carregada em memória, atrás de um checkbox desmarcado (caso DEM-79).
  const matchesFilters = (d: any) => {
    const s = search.toLowerCase();
    const matchSearch = !s ||
      d.title.toLowerCase().includes(s) ||
      d.code.toLowerCase().includes(s) ||
      (d.description || '').toLowerCase().includes(s) ||
      (d.clientName || '').toLowerCase().includes(s);
    const matchStatus = statusFilter === 'Todos' || d.status === statusFilter;
    const matchSystem = systemFilter === 'Todos' || d.system === systemFilter;
    const matchType = typeFilter === 'Todos' || d.type === typeFilter;
    const matchPriority = priorityFilter === 'Todos' || d.priority === priorityFilter;
    const matchAssignee = assigneeFilter === 'Todos' ||
      (assigneeFilter === 'sem' ? !d.assigneeId : d.assigneeId === parseInt(assigneeFilter));
    const matchMine = !mineFilter ||
      (mineFilter === 'assignee' ? d.assigneeId === user?.id : d.reporterId === user?.id);
    return matchSearch && matchStatus && matchSystem && matchType && matchPriority && matchAssignee && matchMine;
  };

  const passesClosedGate = (d: any) => {
    if (statusFilter !== 'Todos') return true;
    const isClosed = d.status === 'concluida' || d.status === 'descartada';
    return showClosed || !isClosed;
  };

  const matching = demands.filter(matchesFilters);
  const filtered = matching.filter(passesClosedGate);
  /** Casam com os filtros, mas o gate de encerradas está segurando. */
  const hiddenClosedCount = matching.length - filtered.length;

  // Stats
  const openCount = demands.filter(d => d.status === 'aberta').length;
  const inProgressCount = demands.filter(d => d.status === 'em_andamento').length;
  const waitingCount = demands.filter(d => d.status === 'aguardando_validacao').length;
  const doneCount = demands.filter(d => d.status === 'concluida').length;

  const badge = (label: string, cls: string) => (
    <span className={`inline-block text-[10px] font-semibold uppercase px-1.5 py-0.5 rounded border ${cls}`}>{label}</span>
  );

  const statusBadge = (status: string) => {
    return badge(STATUS_LABELS[status] || status, comBorda(STATUS_TONE[status] || 'neutral'));
  };

  // === Botões de ação de status conforme permissão ===
  // Cor: são ações, não status. Cada uma tinha a cor do status de destino; agora neutras, e Concluir é a primária.
  const statusActions = (d: Demand) => {
    const actions: { label: string; to: string; cls: string; icon?: string }[] = [];
    if (d.status === 'aberta' && canMove(d, 'em_andamento')) {
      actions.push({ label: 'Iniciar', to: 'em_andamento', cls: ACAO_NEUTRA, icon: 'clock' });
    }
    if (d.status === 'em_andamento' && canMove(d, 'aguardando_validacao')) {
      actions.push({ label: 'Enviar p/ validação', to: 'aguardando_validacao', cls: ACAO_NEUTRA, icon: 'send' });
    }
    if (d.status === 'aguardando_validacao' && canMove(d, 'em_andamento')) {
      actions.push({ label: 'Devolver', to: 'em_andamento', cls: ACAO_NEUTRA, icon: 'refresh' });
    }
    if (canMove(d, 'concluida')) {
      actions.push({ label: d.status === 'aguardando_validacao' ? 'Validar e concluir' : 'Concluir', to: 'concluida', cls: ACAO_PRIMARIA, icon: 'check' });
    }
    if (canMove(d, 'descartada')) {
      actions.push({ label: 'Descartar', to: 'descartada', cls: ACAO_NEUTRA, icon: 'ban' });
    }
    if ((d.status === 'concluida' || d.status === 'descartada') && canMove(d, 'aberta')) {
      actions.push({ label: 'Reabrir', to: 'aberta', cls: ACAO_NEUTRA, icon: 'refresh' });
    }
    return actions;
  };

  if (loading && demands.length === 0) {
    return (
      <div className='flex items-center justify-center h-64'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500'></div>
      </div>
    );
  }

  const demandAttachments = (detail?.attachments || []).filter(a => !a.commentId);
  const commentAttachmentsOf = (commentId: number) => (detail?.attachments || []).filter(a => a.commentId === commentId);

  return (
    <div className='space-y-4'>
      {/* Summary Cards */}
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {[
          { label: 'Abertas', value: openCount, color: TONE_TEXT.progress, icon: 'clipboard', status: 'aberta' },
          { label: 'Em andamento', value: inProgressCount, color: TONE_TEXT.warning, icon: 'clock', status: 'em_andamento' },
          { label: 'Aguardando validação', value: waitingCount, color: TONE_TEXT.info, icon: 'send', status: 'aguardando_validacao' },
          { label: 'Concluídas', value: doneCount, color: TONE_TEXT.success, icon: 'check', status: 'concluida' },
        ].map((card) => (
          <button
            key={card.label}
            type='button'
            onClick={() => setStatusFilter(statusFilter === card.status ? 'Todos' : card.status)}
            title={statusFilter === card.status ? 'Remover filtro' : `Filtrar: ${card.label}`}
            className={`bg-slate-800/50 rounded-xl p-4 border text-left transition-all cursor-pointer ${statusFilter === card.status ? 'border-slate-700 ring-1 ring-orange-500/60 bg-orange-500/5' : 'border-slate-700 hover:border-slate-500'}`}
          >
            <div className='flex items-center justify-between'>
              <div>
                <p className='text-sm text-slate-400'>{card.label}</p>
                <p className={`text-2xl font-bold whitespace-nowrap mt-1 ${card.color}`}>{card.value}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Toolbar */}
      <div className='bg-slate-800/50 rounded-xl border border-slate-700 p-4 space-y-3'>
        <div className='flex flex-col md:flex-row gap-3'>
          <div className='relative flex-1'>
            <Icon name='search' className='absolute left-3 top-3 w-5 h-5 text-slate-500' />
            <input
              type='text'
              placeholder='Buscar por código, título, descrição, cliente...'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={`w-full pl-10 pr-4 py-2.5 placeholder-slate-500 rounded-lg focus:outline-none ${campo}`}
            />
          </div>
          <div className='flex gap-2'>
            <div className='flex rounded-lg border border-slate-700 overflow-hidden'>
              <button
                onClick={() => setView('list')}
                className={`flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium ${view === 'list' ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}
              >
                <Icon name='list' className='w-4 h-4' /> Lista
              </button>
              <button
                onClick={() => setView('kanban')}
                className={`flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium ${view === 'kanban' ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}
              >
                <Icon name='kanban' className='w-4 h-4' /> Kanban
              </button>
            </div>
            <button
              onClick={() => loadData()}
              disabled={loading}
              title='Atualizar lista'
              className='flex items-center justify-center px-3 py-2.5 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 border border-slate-700 disabled:opacity-50'
            >
              <Icon name='refresh' className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
            </button>
            {carga.atualizadoEm !== null && <button
              onClick={() => setShowMetrics(true)}
              title='Métricas (lead time)'
              className='flex items-center justify-center px-3 py-2.5 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 border border-slate-700'
            >
              <Icon name='chart' className='w-5 h-5' />
            </button>}
            {carga.estado === 'pronto' && <button
              onClick={handleCreate}
              className='flex items-center gap-2 px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium whitespace-nowrap'
            >
              <Icon name='plus' className='w-5 h-5' />
              Nova Demanda
            </button>}
          </div>
        </div>
        {erroDosUsuarios && (
          <div role='alert' className='px-3 py-2 rounded-lg border border-amber-600/50 bg-amber-500/10 text-xs text-amber-200' data-pessoas='nao-carregaram'>
            A lista de pessoas não carregou ({erroDosUsuarios}). Os responsáveis das demandas aparecem certos, mas não dá
            para escolher um responsável novo até a lista carregar: só manter o atual ou deixar sem.
            <button type='button' onClick={loadData} className='ml-2 px-2 py-0.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 font-medium'>Tentar de novo</button>
          </div>
        )}
        <div className='flex flex-wrap gap-2 items-center'>
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className={`px-3 py-2 ${campo} text-sm rounded-lg focus:outline-none`}>
            <option value='Todos'>Status: Todos</option>
            {KANBAN_COLUMNS.map(s => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
          </select>
          <select value={systemFilter} onChange={(e) => setSystemFilter(e.target.value)} className={`px-3 py-2 ${campo} text-sm rounded-lg focus:outline-none`}>
            <option value='Todos'>Sistema: Todos</option>
            {Object.entries(SYSTEM_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} className={`px-3 py-2 ${campo} text-sm rounded-lg focus:outline-none`}>
            <option value='Todos'>Tipo: Todos</option>
            {Object.entries(TYPE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <select value={priorityFilter} onChange={(e) => setPriorityFilter(e.target.value)} className={`px-3 py-2 ${campo} text-sm rounded-lg focus:outline-none`}>
            <option value='Todos'>Prioridade: Todas</option>
            {Object.entries(PRIORITY_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <select value={assigneeFilter} onChange={(e) => setAssigneeFilter(e.target.value)} className={`px-3 py-2 ${campo} text-sm rounded-lg focus:outline-none`}>
            <option value='Todos'>Responsável: Todos</option>
            <option value='sem'>Sem responsável</option>
            {pessoasDoFiltro.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
          <button
            type='button'
            onClick={() => setMineFilter(mineFilter === 'assignee' ? null : 'assignee')}
            className={`px-3 py-2 text-sm rounded-lg border transition-colors ${mineFilter === 'assignee' ? 'bg-orange-500/20 text-orange-400 border-orange-500/50' : 'bg-slate-800 text-slate-400 border-slate-700 hover:text-white'}`}
          >
            Minhas
          </button>
          <button
            type='button'
            onClick={() => setMineFilter(mineFilter === 'reporter' ? null : 'reporter')}
            className={`px-3 py-2 text-sm rounded-lg border transition-colors ${mineFilter === 'reporter' ? 'bg-orange-500/20 text-orange-400 border-orange-500/50' : 'bg-slate-800 text-slate-400 border-slate-700 hover:text-white'}`}
          >
            Criadas por mim
          </button>
          <label className='flex items-center gap-2 text-sm text-slate-400 cursor-pointer ml-auto'>
            <input
              type='checkbox'
              checked={showClosed}
              onChange={(e) => setShowClosed(e.target.checked)}
              className='rounded border-slate-600 bg-slate-800 text-orange-500 focus:ring-orange-500'
            />
            Mostrar encerradas
          </label>
        </div>
      </div>

      {/* D3: a lista e o Kanban só com a carga; sem ela, a tela diz que não leu (não "Nenhuma demanda"). */}
      <EstadoDaLista carga={carga} temDados={carga.atualizadoEm !== null} oQue='as demandas' onTentarDeNovo={loadData} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
      {/* Lista */}
      {view === 'list' && (
        <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full'>
              <thead className='bg-slate-800/80 border-b border-slate-700'>
                <tr>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Código</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Título</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Sistema</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Tipo</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Prioridade</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Status</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Responsável</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Criado por</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Idade</th>
                  <th className='px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase'>Atualizado</th>
                </tr>
              </thead>
              <tbody className='divide-y divide-slate-800'>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={10} className='px-4 py-10 text-center text-slate-500'>
                      {hiddenClosedCount > 0 ? (
                        <>
                          Nenhuma demanda aberta com esses filtros.{' '}
                          <button
                            type='button'
                            onClick={() => setShowClosed(true)}
                            className='text-slate-200 hover:text-white underline underline-offset-2'
                          >
                            {hiddenClosedCount === 1
                              ? 'Mostrar 1 encerrada que casa com a busca'
                              : `Mostrar ${hiddenClosedCount} encerradas que casam com a busca`}
                          </button>
                        </>
                      ) : (
                        'Nenhuma demanda encontrada'
                      )}
                    </td>
                  </tr>
                ) : filtered.map((d) => (
                  <tr
                    key={d.id}
                    onClick={() => refreshDetail(d.id)}
                    className='hover:bg-slate-800/50 cursor-pointer transition-colors'
                  >
                    <td className='px-4 py-3 text-sm font-mono text-slate-300 whitespace-nowrap'>
                      {hasNews(d) && <span className='inline-block w-2 h-2 rounded-full bg-orange-400 mr-1.5 align-middle' title='Atividade nova desde sua última visita' />}
                      {d.code}
                    </td>
                    <td className='px-4 py-3 text-sm text-white max-w-[320px]'>
                      <span className='line-clamp-1'>{d.title}</span>
                      {d.clientName && <span className='text-xs text-slate-500'>{d.clientName}</span>}
                    </td>
                    <td className='px-4 py-3 text-sm text-slate-300 whitespace-nowrap'>{SYSTEM_LABELS[d.system] || d.system}</td>
                    <td className='px-4 py-3 whitespace-nowrap'>{badge(TYPE_LABELS[d.type] || d.type, TYPE_COLORS[d.type] || '')}</td>
                    <td className='px-4 py-3 whitespace-nowrap'>{badge(PRIORITY_LABELS[d.priority] || d.priority, PRIORITY_COLORS[d.priority] || '')}</td>
                    <td className='px-4 py-3 whitespace-nowrap'>{statusBadge(d.status)}</td>
                    <td className='px-4 py-3 text-sm text-slate-300 whitespace-nowrap'>{d.assignee?.name || '—'}</td>
                    <td className='px-4 py-3 text-sm text-slate-400 whitespace-nowrap'>{d.reporter?.name || '—'}</td>
                    <td className='px-4 py-3 text-sm whitespace-nowrap' title={`Criada em ${fmtDateTime(d.createdAt)}`}>
                      {(() => { const a = ageInfo(d); return <span className={a.cls}>{a.label}</span>; })()}
                    </td>
                    <td className='px-4 py-3 text-sm text-slate-500 whitespace-nowrap' title={fmtDateTime(d.updatedAt)}>{fmtRelativeTime(d.updatedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Kanban */}
      {view === 'kanban' && (
        <div className='grid grid-cols-2 md:grid-cols-5 gap-3'>
          {KANBAN_COLUMNS.map((status) => {
            // No Kanban a coluna JÁ é o filtro de status: aplicar o gate de
            // encerradas aqui deixaria as colunas "Concluída" e "Descartada"
            // zeradas com demandas dentro delas.
            const colDemands = matching.filter(d => d.status === status);
            const tom = STATUS_TONE[status] || 'neutral';
            return (
              <div key={status} className='flex flex-col'>
                <div className={`bg-slate-800 border-t-2 ${TONE_BORDER[tom]} ${TONE_TEXT[tom]} px-3 py-2.5 rounded-t-lg`}>
                  <div className='flex items-center justify-between'>
                    <span className='font-semibold text-sm'>{STATUS_LABELS[status]}</span>
                    <span className='bg-slate-700 text-slate-200 px-2 py-0.5 rounded-full text-xs font-semibold'>{colDemands.length}</span>
                  </div>
                </div>
                <div
                  className='bg-slate-900 border-2 border-t-0 border-slate-800 rounded-b-lg p-2 space-y-2 flex-1 min-h-[300px] max-h-[calc(100vh-420px)] overflow-y-auto'
                  onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('ring-2', 'ring-orange-500'); }}
                  onDragLeave={(e) => { e.currentTarget.classList.remove('ring-2', 'ring-orange-500'); }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.currentTarget.classList.remove('ring-2', 'ring-orange-500');
                    const demandId = e.dataTransfer.getData('demandId');
                    if (!demandId) return;
                    const demand = demands.find((d) => d.id === parseInt(demandId));
                    if (!demand || demand.status === status) return;
                    if (!canMove(demand, status)) {
                      avisar('Você não tem permissão para mover esta demanda para "' + STATUS_LABELS[status] + '"', 'warning');
                      return;
                    }
                    requestStatusChange(demand, status);
                  }}
                >
                  {colDemands.map((d) => (
                    <div
                      key={d.id}
                      draggable={canDrag(d)}
                      onDragStart={(e) => { e.dataTransfer.setData('demandId', d.id.toString()); e.currentTarget.classList.add('opacity-50'); }}
                      onDragEnd={(e) => { e.currentTarget.classList.remove('opacity-50'); }}
                      onClick={() => refreshDetail(d.id)}
                      className={`bg-slate-800 rounded-lg border border-slate-700 hover:border-slate-500 transition-all p-2.5 ${canDrag(d) ? 'cursor-grab active:cursor-grabbing' : 'cursor-pointer'}`}
                    >
                      <div className='flex items-start justify-between gap-1 mb-1'>
                        <span className='text-[10px] font-mono text-slate-300'>
                          {hasNews(d) && <span className='inline-block w-1.5 h-1.5 rounded-full bg-orange-400 mr-1 align-middle' title='Atividade nova' />}
                          {d.code}
                        </span>
                        {badge(PRIORITY_LABELS[d.priority] || d.priority, PRIORITY_COLORS[d.priority] || '')}
                      </div>
                      <h4 className='font-medium text-white text-xs leading-tight line-clamp-2 mb-1.5'>{d.title}</h4>
                      <div className='flex items-center justify-between text-[10px] text-slate-500'>
                        <span>{SYSTEM_LABELS[d.system]} · {TYPE_LABELS[d.type]} · {(() => { const a = ageInfo(d); return <span className={a.cls}>{a.label}</span>; })()}</span>
                        {d.assignee && (
                          <span className='w-4 h-4 rounded-full bg-slate-600 text-white text-[8px] font-bold flex items-center justify-center' title={d.assignee.name}>
                            {d.assignee.name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
      </EstadoDaLista>

      {/* Modal criar/editar */}
      {modal && (
        // Formulário: não fecha ao clicar fora, como já era. Na criação, a caixa
        // inteira continua sendo zona de soltar arquivo (aoSoltarArquivos).
        <CascaDeModal
          largura='base'
          titulo={modal === 'edit' ? `Editar ${detail?.code}` : 'Nova Demanda'}
          onClose={() => setModal(null)}
          aoSoltarArquivos={modal === 'create' ? (e) => handleDropFiles(e, (att) => setPendingAtts((prev) => [...prev, att])) : undefined}
          corpoClassName='p-5 space-y-4'
          rodape={
            <div className='ml-auto flex gap-2'>
              <button onClick={() => setModal(null)} className='px-4 py-2 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 border border-slate-700'>Cancelar</button>
              <button onClick={handleSave} disabled={saving} className='px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>
                {saving ? 'Salvando...' : modal === 'edit' ? 'Salvar' : 'Criar Demanda'}
              </button>
            </div>
          }
        >
              {modal === 'create' && (
                <p className='text-xs text-slate-400' data-testid='frase-do-responsavel'>{FRASE_DO_RESPONSAVEL}</p>
              )}
              <div>
                <label className='block text-sm text-slate-400 mb-1'>Título *</label>
                <input
                  type='text'
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  placeholder='Resumo curto do problema/melhoria'
                  className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none`}
                  autoFocus
                />
              </div>
              <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
                <div>
                  <label className='block text-sm text-slate-400 mb-1'>Sistema *</label>
                  <select value={form.system} onChange={(e) => setForm({ ...form, system: e.target.value })} className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none`}>
                    {Object.entries(SYSTEM_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                </div>
                <div>
                  <label className='block text-sm text-slate-400 mb-1'>Tipo *</label>
                  <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none`}>
                    {Object.entries(TYPE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                </div>
                <div>
                  <label className='block text-sm text-slate-400 mb-1'>Prioridade</label>
                  <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none`}>
                    {Object.entries(PRIORITY_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className='block text-sm text-slate-400 mb-1'>Cliente onde apareceu (opcional)</label>
                <input
                  type='text'
                  value={form.clientName}
                  onChange={(e) => setForm({ ...form, clientName: e.target.value })}
                  placeholder='Ex.: LOGIN SISTEMAS'
                  className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none`}
                />
              </div>
              <div>
                <label className='block text-sm text-slate-400 mb-1'>
                  Descrição <span className='text-slate-600'>(markdown; cole prints com Ctrl+V)</span>
                </label>
                <textarea
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  onPaste={modal === 'create' ? (e) => handlePaste(e, (att) => setPendingAtts((prev) => [...prev, att])) : undefined}
                  rows={6}
                  placeholder='Descreva o problema, passos para reproduzir, comportamento esperado...'
                  className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none resize-y`}
                />
                {modal === 'create' && (
                  <>
                    {renderPendingChips(pendingAtts, (idx) => setPendingAtts((prev) => prev.filter((_, i) => i !== idx)))}
                    <label className='inline-flex items-center gap-1.5 mt-2 text-xs text-slate-400 hover:text-white cursor-pointer'>
                      <Icon name='paperclip' className='w-4 h-4' />
                      Anexar arquivo (imagem/PDF)
                      <input type='file' multiple accept={ACEITA_NO_SELETOR} className='hidden' onChange={(e) => handleFileSelect(e, (att) => setPendingAtts((prev) => [...prev, att]))} />
                    </label>
                  </>
                )}
              </div>
        </CascaDeModal>
      )}

      {/* Modal concluir (comentário obrigatório) */}
      {concludeModal && (
        // Comentário obrigatório digitado: não fecha ao clicar fora, como já era;
        // ganha o ×. A primária verde vira o laranja.
        <CascaDeModal
          largura='xs'
          zIndex='z-[60]'
          titulo={`Concluir ${concludeModal.code}`}
          onClose={() => setConcludeModal(null)}
          temEdicaoNaoSalva={() => !!concludeComment.trim()}
          topo={<p className='px-5 pt-3 text-xs text-slate-400'>Descreva o que foi feito — o comentário é obrigatório e fica na trilha.</p>}
          corpoClassName='p-5'
          rodape={
            <div className='ml-auto flex gap-2'>
              <button onClick={() => setConcludeModal(null)} className='px-4 py-2 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 border border-slate-700'>Cancelar</button>
              <button onClick={handleConclude} className='px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium'>Concluir</button>
            </div>
          }
        >
              <textarea
                value={concludeComment}
                onChange={(e) => setConcludeComment(e.target.value)}
                rows={4}
                placeholder='O que foi feito para resolver esta demanda?'
                className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none resize-y`}
                autoFocus
              />
        </CascaDeModal>
      )}

      {/* Modal detalhe */}
      {detail && !modal && (
        // Ficha com comentário digitado no rodapé: não fecha ao clicar fora, como já
        // era. A caixa inteira segue sendo zona de soltar (anexo do comentário).
        // Selos = status, tipo, prioridade, sistema; ações de status, responsável,
        // copiar link, editar e excluir ficam no topo, fora da rolagem; o compositor
        // do comentário é o rodapé.
        <CascaDeModal
          largura='md'
          titulo={detail.title}
          subtitulo={<>{detail.code} · criada por {detail.reporter?.name || '—'} {fmtRelativeTime(detail.createdAt)}{detail.clientName ? ` · Cliente: ${detail.clientName}` : ''}</>}
          selos={<>
            {statusBadge(detail.status)}
            {badge(TYPE_LABELS[detail.type] || detail.type, TYPE_COLORS[detail.type] || '')}
            {badge(PRIORITY_LABELS[detail.priority] || detail.priority, PRIORITY_COLORS[detail.priority] || '')}
            {badge(SYSTEM_LABELS[detail.system] || detail.system, 'bg-slate-500/20 text-slate-300 border-slate-500/30')}
          </>}
          onClose={() => setDetail(null)}
          // 12/10/2026 (conferência em tela): sem esta resposta a casca perguntava "Fechar sem salvar?" no Esc mesmo sem nada
          // digitado. O único digitável da ficha é o compositor do comentário (texto e anexos).
          temEdicaoNaoSalva={() => !!commentText.trim() || commentAtts.length > 0}
          aoSoltarArquivos={(e) => handleDropFiles(e, (att) => setCommentAtts((prev) => [...prev, att]))}
          topo={
            <div className='flex flex-wrap items-center gap-2 px-5 py-3 border-b border-central-borda'>
              {statusActions(detail).map((a) => (
                <button
                  key={a.to + a.label}
                  onClick={() => requestStatusChange(detail, a.to)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border ${a.cls}`}
                >
                  {a.icon && <Icon name={a.icon} className='w-3.5 h-3.5' />}
                  {a.label}
                </button>
              ))}
              <div className='flex items-center gap-1.5 ml-auto'>
                <Icon name='user' className='w-4 h-4 text-slate-500' />
                {canChangeAssignee(detail) ? (
                  <select
                    value={detail.assigneeId || ''}
                    onChange={(e) => handleChangeAssignee(detail, e.target.value ? parseInt(e.target.value) : null)}
                    className={`px-2 py-1.5 ${campo} text-xs rounded-lg focus:outline-none`}
                  >
                    <option value=''>Sem responsável</option>
                    {/* O responsável atual é sempre opção: sem isto, fora da lista ele aparecia como "Sem responsável". */}
                    {opcaoAtualForaDaLista(users, detail.assigneeId, detail.assignee?.name || `responsável #${detail.assigneeId}`, !!erroDosUsuarios)}
                    {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>
                ) : (
                  <span className='text-xs text-slate-300'>{detail.assignee?.name || 'Sem responsável'}</span>
                )}
                <button
                  onClick={() => {
                    navigator.clipboard?.writeText(`${detail.code} · ${detail.title}\n${window.location.origin}/?demanda=${detail.code}`)
                      .then(() => { setLinkCopied(true); setTimeout(() => setLinkCopied(false), 2000); })
                      .catch(() => { /* clipboard indisponível */ });
                  }}
                  className={`p-2 rounded-lg hover:bg-slate-800 ${linkCopied ? 'text-green-400' : 'text-slate-400 hover:text-white'}`}
                  title={linkCopied ? 'Link copiado!' : 'Copiar link da demanda'}
                >
                  <Icon name={linkCopied ? 'check' : 'link'} className='w-4 h-4' />
                </button>
                {canEditDemand(detail) && (
                  <button onClick={() => handleEdit(detail)} className='p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg' title='Editar demanda'>
                    <Icon name='edit' className='w-4 h-4' />
                  </button>
                )}
                {isAdmin && (
                  <button onClick={() => handleDelete(detail)} className='p-2 text-slate-400 hover:text-red-400 hover:bg-slate-800 rounded-lg' title='Excluir demanda'>
                    <Icon name='trash' className='w-4 h-4' />
                  </button>
                )}
              </div>
            </div>
          }
          corpoClassName='p-5 space-y-5'
          rodape={
            <div className='w-full'>
              <textarea
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                onPaste={(e) => handlePaste(e, (att) => setCommentAtts((prev) => [...prev, att]))}
                rows={2}
                placeholder='Escreva um comentário (markdown; cole prints com Ctrl+V)...'
                className={`w-full px-3 py-2.5 ${campo} rounded-lg focus:outline-none resize-y`}
              />
              {renderPendingChips(commentAtts, (idx) => setCommentAtts((prev) => prev.filter((_, i) => i !== idx)))}
              <div className='flex items-center justify-between mt-2'>
                <label className='inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-white cursor-pointer'>
                  <Icon name='paperclip' className='w-4 h-4' />
                  Anexar
                  <input type='file' multiple accept={ACEITA_NO_SELETOR} className='hidden' onChange={(e) => handleFileSelect(e, (att) => setCommentAtts((prev) => [...prev, att]))} />
                </label>
                <button
                  onClick={handleSendComment}
                  disabled={sendingComment || (!commentText.trim() && commentAtts.length === 0)}
                  className='flex items-center gap-1.5 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong text-sm font-medium disabled:opacity-40'
                >
                  <Icon name='send' className='w-4 h-4' />
                  {sendingComment ? 'Enviando...' : 'Comentar'}
                </button>
              </div>
            </div>
          }
        >
            {/* Body */}
            <>
              {/* Descrição */}
              {detail.description && (
                <div className='bg-central-elevado/50 border border-central-borda rounded-lg p-4'>
                  <MarkdownView markdown={detail.description} />
                </div>
              )}

              {/* Anexos da demanda */}
              {demandAttachments.length > 0 && (
                <div>
                  <h4 className='text-xs font-semibold text-slate-400 uppercase mb-2 flex items-center gap-1.5'>
                    <Icon name='paperclip' className='w-3.5 h-3.5' /> Anexos ({demandAttachments.length})
                  </h4>
                  <div className='grid grid-cols-3 md:grid-cols-5 gap-2'>
                    {demandAttachments.map((att) => (
                      <AttachmentCard
                        key={att.id}
                        attachment={att}
                        canDelete={isAdmin || att.uploadedById === user?.id}
                        onDelete={() => handleDeleteAttachment(att)}
                      />
                    ))}
                  </div>
                </div>
              )}

              {/* Thread */}
              <div>
                <h4 className='text-xs font-semibold text-slate-400 uppercase mb-3'>
                  Conversa e histórico ({(detail.comments || []).length})
                </h4>
                <div className='relative'>
                  <div className='absolute left-[11px] top-2 bottom-2 w-px bg-slate-700' />
                  <div className='space-y-0'>
                    {(detail.comments || []).length === 0 && (
                      <p className='text-sm text-slate-600 pl-8 py-2'>Nenhum comentário ainda</p>
                    )}
                    {(detail.comments || []).map((c) => {
                      if (c.kind === 'status_change') {
                        const paraTom = STATUS_TONE[c.metadata?.to || ''] || 'progress';
                        return (
                          <div key={c.id} className='relative flex gap-3 py-2.5'>
                            <div className={`relative z-10 flex-shrink-0 w-[23px] h-[23px] rounded-full border-2 ${TONE_BORDER[paraTom]} ${TONE_BADGE[paraTom]} flex items-center justify-center mt-0.5`}>
                              <div className={`w-2 h-2 rounded-full ${STATUS_DOT[c.metadata?.to || ''] || STATUS_DOT.aberta}`} />
                            </div>
                            <div className='flex-1 min-w-0'>
                              <p className='text-xs text-slate-400'>
                                <span className='text-slate-300 font-medium'>{c.author?.name || '—'}</span>
                                {' moveu de '}
                                <span className='text-slate-300'>{STATUS_LABELS[c.metadata?.from || ''] || c.metadata?.from}</span>
                                {' → '}
                                <span className={TONE_TEXT[paraTom]}>{STATUS_LABELS[c.metadata?.to || ''] || c.metadata?.to}</span>
                                <span className='text-slate-600 ml-2' title={fmtDateTime(c.createdAt)}>{fmtRelativeTime(c.createdAt)}</span>
                              </p>
                              {c.body && <div className='mt-1 text-sm text-slate-300 bg-central-elevado/50 border border-central-borda rounded-lg px-3 py-2'><MarkdownView markdown={c.body} /></div>}
                            </div>
                          </div>
                        );
                      }
                      const atts = commentAttachmentsOf(c.id);
                      return (
                        <div key={c.id} className='relative flex gap-3 py-2.5'>
                          <div className='relative z-10 flex-shrink-0 w-[23px] h-[23px] rounded-full bg-slate-600 text-white text-[9px] font-bold flex items-center justify-center mt-0.5'>
                            {(c.author?.name || '?').split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()}
                          </div>
                          <div className='flex-1 min-w-0'>
                            <p className='text-xs text-slate-500'>
                              <span className='text-slate-300 font-medium'>{c.author?.name || '—'}</span>
                              <span className='ml-2' title={fmtDateTime(c.createdAt)}>{fmtRelativeTime(c.createdAt)}</span>
                            </p>
                            {c.body && (
                              <div className='mt-1 bg-central-elevado/50 border border-central-borda rounded-lg px-3 py-2'>
                                <MarkdownView markdown={c.body} />
                              </div>
                            )}
                            {atts.length > 0 && (
                              <div className='grid grid-cols-3 md:grid-cols-5 gap-2 mt-2'>
                                {atts.map((att) => (
                                  <AttachmentCard
                                    key={att.id}
                                    attachment={att}
                                    canDelete={isAdmin || att.uploadedById === user?.id}
                                    onDelete={() => handleDeleteAttachment(att)}
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
        </CascaDeModal>
      )}

      {/* Modal de métricas (lead time) */}
      {showMetrics && (() => {
        const done = demands.filter((d) => d.status === 'concluida' && d.completedAt);
        const leadOf = (d: Demand) => (new Date(d.completedAt!).getTime() - new Date(d.createdAt).getTime()) / 86400000;
        const avg = (arr: Demand[]) => arr.length ? arr.reduce((s, d) => s + leadOf(d), 0) / arr.length : null;
        const fmtAvg = (v: number | null) => v === null ? '—' : v < 1 ? '<1 dia' : `${v.toFixed(1)} dias`;
        const groupRows = (labelMap: Record<string, string>, key: 'type' | 'system') =>
          Object.entries(labelMap)
            .map(([v, l]) => ({ label: l, items: done.filter((d) => d[key] === v) }))
            .filter((g) => g.items.length > 0);
        return (
          // Só leitura: fecha ao clicar fora, como já era.
          <CascaDeModal
            largura='xs'
            fecharAoClicarFora
            titulo='Métricas — lead time'
            onClose={() => setShowMetrics(false)}
            corpoClassName='p-5 space-y-4 text-sm'
          >
                <div className='flex items-center justify-between'>
                  <span className='text-slate-400'>Concluídas (com data)</span>
                  <span className='text-white font-semibold'>{done.length}</span>
                </div>
                <div className='flex items-center justify-between'>
                  <span className='text-slate-400'>Tempo médio abertura → conclusão</span>
                  <span className='text-green-400 font-semibold'>{fmtAvg(avg(done))}</span>
                </div>
                {groupRows(TYPE_LABELS, 'type').length > 0 && (
                  <div>
                    <p className='text-xs uppercase font-semibold text-slate-500 mb-2'>Por tipo</p>
                    {groupRows(TYPE_LABELS, 'type').map((g) => (
                      <div key={g.label} className='flex items-center justify-between py-1 border-b border-central-borda last:border-0'>
                        <span className='text-slate-300'>{g.label} <span className='text-slate-500'>({g.items.length})</span></span>
                        <span className='text-slate-300'>{fmtAvg(avg(g.items))}</span>
                      </div>
                    ))}
                  </div>
                )}
                {groupRows(SYSTEM_LABELS, 'system').length > 0 && (
                  <div>
                    <p className='text-xs uppercase font-semibold text-slate-500 mb-2'>Por sistema</p>
                    {groupRows(SYSTEM_LABELS, 'system').map((g) => (
                      <div key={g.label} className='flex items-center justify-between py-1 border-b border-central-borda last:border-0'>
                        <span className='text-slate-300'>{g.label} <span className='text-slate-500'>({g.items.length})</span></span>
                        <span className='text-slate-300'>{fmtAvg(avg(g.items))}</span>
                      </div>
                    ))}
                  </div>
                )}
                {done.length === 0 && <p className='text-slate-500'>Nenhuma demanda concluída ainda — as médias aparecem conforme as demandas forem concluídas.</p>}
          </CascaDeModal>
        );
      })()}
    </div>
  );
}
